import {
  InputAdornment,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material'
import { FC } from 'react'

type TextFieldWithCounterProps = {
  /** 最大文字数 */
  maxLength: number
  /** 現在の値 */
  value: string
  /** 背景色（デフォルト: 'white'） */
  backgroundColor?: string
  /** カウンター非表示（デフォルト: false） */
  hideCounter?: boolean
} & Omit<TextFieldProps, 'value' | 'slotProps'>

/**
 * 文字数カウンター付きTextField
 *
 * - 入力文字数と最大文字数を表示
 * - 最大文字数を超えると赤色で警告表示
 * - htmlInput.maxLengthで入力制限
 */
export const TextFieldWithCounter: FC<TextFieldWithCounterProps> = ({
  maxLength,
  value,
  backgroundColor = 'white',
  hideCounter = false,
  ...textFieldProps
}) => {
  const currentLength = value?.length ?? 0
  const isOverLimit = currentLength > maxLength

  return (
    <TextField
      {...textFieldProps}
      value={value}
      slotProps={{
        htmlInput: {
          maxLength,
        },
        input: {
          sx: {
            backgroundColor,
            color: isOverLimit ? 'error.main' : undefined,
          },
          endAdornment: hideCounter ? undefined : (
            <InputAdornment position="end">
              <Typography
                variant="body2"
                component="span"
                sx={{
                  color: isOverLimit ? 'error.main' : 'text.secondary',
                }}
              >
                {currentLength} / {maxLength}
              </Typography>
            </InputAdornment>
          ),
        },
      }}
    />
  )
}
